import React from 'react';
import KickImage from 'Reuseables/KickImage';

interface LinkProps {
  to: string
}
const Link: React.FC<LinkProps> = ({ children, to, ...props }) => <a {...props} href={to}>{children}</a>

export default Link